import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import '@nw4/ui/styles';

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { App } from "@/app";
import { NotFoundPage } from "@nw4/ui";
import { AppMantineProvider } from "@nw4/theme";

const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(
    <StrictMode>
        <BrowserRouter>
            <AppMantineProvider>
                <Routes>
                    {/* Main route: richiede formGuid nell'URL */}
                    <Route path="/:formGuid" element={<App />} />
                    {/* 404: nessun formGuid (/, /foo/bar, ecc.) */}
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </AppMantineProvider>
        </BrowserRouter>
    </StrictMode>
);
